import styled from 'styled-components';

export const LinkButton = styled.button`
  background: none !important;
  border: none;
  padding: 0 !important;
  font-family: arial, sans-serif;
  color: #069;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
  }
`;
